// Header.js
import React, { useState, useRef, useEffect  } from 'react';
import '../Assets/Header.css';
import logo from '../Assets/logo.png';
import configs from '../Configs/Config';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const siteTitle = configs.siteName
//    const siteLongTitle = configs.siteLongTitle
    const menuRef = useRef(null);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Close menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsOpen(false);
        }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    return (
        <header className="header" ref={menuRef}>
            
            <div className="logo">
                <a href="/">
                    <img src={logo} alt="ABIPP" />
                </a>
                <span id="siteTitle" className='siteTitle'>{siteTitle}</span>
                
                <p>{t('siteLongTitle')}</p>
                <LanguageSwitcher />
            </div>

            
            <nav className={`nav ${isOpen ? 'open' : 'close'}`}>
                <a href="/#home">{t('menu.home')}</a>
                <a href="/#about">{t('menu.about')}</a>
                <a href="/#mission">{t('menu.mission')}</a>
                <a href="/donate">{t('menu.donate')}</a>
                <a href="/join-movement">{t('menu.join')}</a>
                <a href="/news-and-media">{t('menu.newsmedia')}</a>
                <a href="/#contact">{t('menu.contact')}</a>
                
            </nav>

            <div className={`hamburger ${isOpen ? 'open' : 'close'}`} onClick={toggleMenu}>
                <div className="bar" />
                <div className="bar" />
                <div className="bar" />
            </div>
            
        </header>
    );
};

export default Header;